import { MessagePayload } from '@firebase/messaging';
import mylaClient from 'shared/api/myla';
import { API_PATHS } from 'shared/constants';

export async function sendDeviceToken(token: string) {
  const res = await mylaClient.post<string>(API_PATHS.DEVICE_TOKEN, { token });
  return res.data;
}
